import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { base_url } from "../../utils/apis";
// import { ID } from "../../utils/utils";

// Do NOT read localStorage at module-eval time -- read inside the thunk instead.
export const getClaims = createAsyncThunk("claim", async (id, thunkAPI) => {
  try {
    // read most-up-to-date user info here
    const loggedInUser = localStorage.getItem("user");
    const currentUser = JSON.parse(loggedInUser);

    const body = new FormData();
    // prefer explicit id param if passed, otherwise use current user's id
    // body.append("userid", id ?? currentUser?.userid);
    body.append("action", "list");

    const response = await fetch(base_url + "claims.php", {
      method: "POST",
      credentials: "include",
      body: body,
    });
    const res = await response.json();
    // console.log("[getClaims] response:", res);
    return res;
  } catch (error) {
    console.error("[getClaims] error:", error);
    return thunkAPI.rejectWithValue(error?.message ?? "Unknown error");
  }
});

const claimSlice = createSlice({
  name: "claim",
  initialState: {
    claim_data: [],
    loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getClaims.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getClaims.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      // guard against undefined payload (thunk may reject or return undefined)
      if (data && data.success) {
        state.claim_data = data.message;
      } else {
        state.claim_data = [];
      }
    });
    builder.addCase(getClaims.rejected, (state, action) => {
      state.loading = false;
      state.claim_data = [];
      // optionally store action.payload or action.error.message for UI debugging
      // state.error = action.payload || action.error?.message;
    });
  },
});
export default claimSlice.reducer;
